// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import translate from "@insite/client-framework/Translate";
import { xHasRole } from "@synd/App/Store/Selectors/GeneralSelectors";
import { USER_ROLES } from "@synd/XDL/constants";

export const xGetFulfillmentLabel = (state: ApplicationState) => {
    const { fulfillmentMethod, isAuthenticated, rememberMe, isGuest, billToId, pickUpWarehouse } = getSession(state);
    const billToState = getBillToState(state, billToId);
    const isRetailer = xHasRole(state, USER_ROLES.RETAILER);
    const { value: billTo } = billToState;
    let addressLabel = "";
    let addressValue = "";
    let fullAddressValue = "";
    if (fulfillmentMethod === FulfillmentMethod.Ship && (isAuthenticated || rememberMe) && !isGuest && billTo) {
        addressLabel = translate(isRetailer ? "Shopping With:" : "Managing:");
        addressValue = translate(billTo.companyName || "-");
        fullAddressValue = translate(billTo.fullAddress);
    } else if (fulfillmentMethod === FulfillmentMethod.PickUp) {
        addressLabel = translate("Pick up");
        addressValue = translate(pickUpWarehouse ? `at ${pickUpWarehouse.description || pickUpWarehouse.name}` : "-");
    }

    return { addressLabel, addressValue, fullAddressValue };
};
